//to be changed after availing exact live URL and after changes
const socketUATURL: string = window.location.protocol === "https:" ? "wss://mstreamuat.edelweiss.in" : "wss://mstreamuat.edelweiss.in";
const socketLIVEURL: string = window.location.protocol === "https:" ? "wss://mstreamuat.edelweiss.in" : "wss://mstreamuat.edelweiss.in";

// Assign object to a variable before exporting as module default  import/no-anonymous-default-export
const socketConfig = {
	socketURL: process.env.REACT_APP_ENV === "production" ? socketLIVEURL : socketUATURL,
	port: 12007
};

export default socketConfig;
